import merge from 'lodash/merge';
import { darken } from '@material-ui/core/styles/colorManipulator';
import { ThemeOptions } from '@material-ui/core/styles/createTheme';

import { overrideMuiTheme } from '@tink/core/src/components/providers/ThemeProvider/muiTheme';

import { tinkLinkTheme, TinkLinkTheme } from './tinkLinkTheme';

export const applyTinkLinkOverrides = (theme: TinkLinkTheme): ThemeOptions => {
  const coreOverrides = overrideMuiTheme(theme);

  // If client does not have custom theme, we can skip applying additional overrides
  if (theme === tinkLinkTheme) {
    return coreOverrides;
  }

  const tinkLinkOverrides = {
    overrides: {
      MuiButton: {
        // text is when a variant and color are not set. For us, it's the secondaryButton.
        text: {
          color: theme.configuration.buttonSecondaryTextColor,

          '&:hover': {
            color: darken(theme.configuration.buttonSecondaryTextColor, 0.08),
          },
        },
        textPrimary: {
          color: theme.configuration.buttonBackgroundColor,

          '&:hover': {
            color: darken(theme.configuration.buttonBackgroundColor, 0.08),
          },
        },
        containedPrimary: {
          '&:hover': {
            color: theme.configuration.buttonTextColor,
            backgroundColor: darken(theme.configuration.buttonBackgroundColor, 0.08),
            '@media (hover: none)': {
              color: theme.configuration.buttonTextColor,
              backgroundColor: darken(theme.configuration.buttonBackgroundColor, 0.08),
            },
          },
        },
      },
      MuiCircularProgress: {
        colorPrimary: {
          color: theme.configuration.primaryColor,
        },
      },
    },
  };

  return merge(coreOverrides, tinkLinkOverrides);
};
